module.exports = __webpack_public_path__ + "static/img/sebastian.4dc895a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sebastian.jpg
// module id = 6FDI
// module chunks = 1